<template>
	<SOSlotBase
		:bg-white="true"
		:loading="pageSetting.loading.list"
		:container-name="'list-history-paylink-content'"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Paylink Konsumen'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-16 border-bottom">
				<div class="f-regular f-14 f-c-midgrey m-d-4">
					Saldo Paylink {{ historyPaylinkData.data.nama_konsumen }}
				</div>
				<div class="f-bold f-18 f-c-black">
					Rp {{ formatRupiah(historyPaylinkData.data.saldo.toString()) }}
				</div>
			</div>

			<div class="p-x-20 p-y-20 f-regular f-14 f-c-midgrey"
			     v-if="historyPaylinkData.data.ispaylink === 0"
			>
				Konsumen ini belum pernah menggunakan Paylink.
			</div>

			<div class="d-flex p-x-20 p-y-12 bg-grey">
				<div class="f-regular f-16 f-c-midgrey">
					Riwayat Aktivitas
					<span class="m-l-4 m-r-4">•</span>
				</div>
				<div>
					<SODropdown
						:id="'dropdown-history-paylink'"
						:title="dropdownItems[dropdownItems.findIndex(a => a.selected === true)].title"
						:items="dropdownItems"
						@update-data="(val) => { dropdownItems = val }"
						@action="doFilter"
					/>
				</div>
			</div>

			<div class="p-x-20" :class="{'bg-white': !pageSetting.loading.list}">
				<SOCardCustomerGlobalTransaksiPaylink
					v-for="transaksi in historyPaylinkData.data.list_transaksi_paylink"
					:key="transaksi.idtransaksi"
					:transaksi="transaksi"
					@detail="detail"
				/>

				<SOLoadMoreLoading :id="'loading-list-history-paylink'" :loading="pageSetting.loading.loadMore"/>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SODropdown from "@/so-components/global/ui/SODropdown";
import SOCardCustomerGlobalTransaksiPaylink
	from "@/so-components/modules/customer-global/SOCardCustomerGlobalTransaksiPaylink";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

const defaultDropdownItems = () => (
	[
		{
			title: "Semua",
			selected: true,
		},
		{
			title: "Transaksi",
			selected: false,
		},
		{
			title: "Top Up",
			selected: false,
		},
	]
)

export default {
	name: "CustomerGlobalPaylink",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,
		SODropdown,
		SOCardCustomerGlobalTransaksiPaylink,
		SOLoadMoreLoading,
	},
	computed: {
		...mapGetters("transaksiSnapcleanModule", {
			historyPaylinkData: "getListHistoryPaylinkKonsumen",
			pagination: "getPagination",
		}),
	},
	data() {
		return {
			idcustomer: "",
			dropdownItems: defaultDropdownItems(),

			pageSetting: {
				loading: {
					list: true,
					loadMore: false,
				},
				error: {
					list: false,
				}
			}
		}
	},
	async mounted() {
		this.idcustomer = this.$route.params.idcustomer
		await this.getHistoryPaylink()
		await this.scroll()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/snapclean/detail/" + this.idcustomer)
			this.$router.back()
		},
		async getHistoryPaylink() {
			const res = await this.$store.dispatch("transaksiSnapcleanModule/fetchListHistoryPaylinkKonsumen", {
				idcustomer: this.idcustomer,
				tipe: this.dropdownItems.findIndex(a => a.selected === true)
			})
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			} else {
				this.pageSetting.loading.list = false;
			}
			this.pageSetting.loading.loadMore = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("transaksiSnapcleanModule/setNextPagination", {
					data: this.historyPaylinkData.data.list_transaksi_paylink
				})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},
		setDefaultFilter() {
			let query = this.$route.query
			if (Object.keys(query).length > 0) {
				this.dropdownItems.forEach((val, key) => {
					if (key !== Number(query.tipe)) {
						this.dropdownItems[key].selected = false
					} else {
						this.dropdownItems[key].selected = true
					}
				})
			} else {
				this.dropdownItems = defaultDropdownItems()
			}
		},
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: "loading-list-history-paylink",
					container: "list-history-paylink-content",
					pagination: this.pagination,
					callback: this.getHistoryPaylink,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		async doFilter() {
			this.pageSetting.loading.list = true
			this.historyPaylinkData.data.list_transaksi_paylink = []
			await this.$store.commit("transaksiSnapcleanModule/resetPagination")
			await this.getHistoryPaylink()
		},
		detail(idtransaksi) {
			this.$router.push("/transaksi/snapclean/detail/" + idtransaksi)
		}
	},
	beforeDestroy() {
		this.$store.commit("transaksiSnapcleanModule/resetListHistoryPaylinkKonsumen")
		this.$store.commit("transaksiSnapcleanModule/resetPagination")
	}
}
</script>